import { render, staticRenderFns } from "./KSggz.vue?vue&type=template&id=68011514&scoped=true"
import script from "./KSggz.vue?vue&type=script&lang=js"
export * from "./KSggz.vue?vue&type=script&lang=js"
import style0 from "./KSggz.vue?vue&type=style&index=0&id=68011514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68011514",
  null
  
)

export default component.exports